import { languages } from '@core/lib/constants/languages';
import errorHandler from '@core/lib/errorHandler/errorHandler';

function LanguageLoader(Api, gettextCatalog, $q, $http) {
  'ngInject';

  const _supportedLang = languages.map(language => language.id);

  let _loadedLanguage = null;

  const self = {
    load: load,
    loadBrowserLanguage: loadBrowserLanguage,
    getBrowserLanguage: getBrowserLanguage,
    _loadTranslationsFile: _loadTranslationsFile,
    _loadRevision: _loadRevision,
  };

  return self;

  /**
   * Load locale file dynamically based on user language
   *
   * @param {String} lang
   * @returns {Promise}
   * @private
   */
  function load(lang) {
    if (_loadedLanguage === lang) {
      return $q.when();
    }

    _loadedLanguage = lang;

    return self
      ._loadRevision(lang)
      .then(revision => self._loadTranslationsFile(lang, revision))
      .then(({ data }) => _setTranslations(lang, data))
      .catch(err => errorHandler.trackError(`Failed to load translation file. ${err.statusText || err.status}`));
  }

  /**
   * Load locale file dynamically based on user language
   *
   * @returns {Promise}
   * @private
   */
  function loadBrowserLanguage() {
    return load(getBrowserLanguage());
  }

  /**
   * @param {String} lang
   * @param {String} revision
   * @returns {Promise}
   * @private
   */
  function _loadTranslationsFile(lang, revision) {
    return $http({
      method: 'GET',
      url: `/translations/${lang}.${revision}.json`,
      ignore404: true,
    });
  }

  /**
   * @returns {Promise}
   * @private
   */
  function _loadRevision(lang) {
    return $http({
      method: 'GET',
      url: '/translations/manifest.json',
      params: { t: Date.now() },
      ignore404: true,
    }).then(({ data }) => data[lang]);
  }

  /**
   * @param {String} lang
   * @param {Object} strings
   * @private
   */
  function _setTranslations(lang, strings) {
    gettextCatalog.setStrings(lang, strings);
    gettextCatalog.setCurrentLanguage(lang);
  }

  /**
   * Returns browser default language if its the supported one
   *
   * @returns {String} browser default language
   */
  function getBrowserLanguage() {
    const lang = navigator.language ? navigator.language.split('-')[0] : '';

    return _supportedLang.includes(lang) ? lang : _supportedLang[0];
  }
}

export { LanguageLoader };
